import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { useQuery } from '~/client/hooks/cqrpc'
import EventsList from '~/client/components/EventsList'

export default function Page() {
  const { document } = useOutletContext()
  const { loading, error, result: events } =
    useQuery('documents.getEvents', { documentId: document.id })
  return <div>
    <EventsList {...{ loading, error, events }}/>
  </div>
}
